module.exports = __webpack_public_path__ + "img/fischer-projektion.de9c0845.png";